module.exports = __webpack_public_path__ + "static/media/calendar.2fdce563.gif";